import { storyblokEditable } from "@storyblok/react";

const ChartCell = ({ blok }) => {
  const type = blok.content_type || "text";

  let content = null;

  if (type === "check") {
    content = (
      <span
        aria-label="Included"
        role="img"
        className="inline-flex items-center justify-center"
      >
        <svg
          viewBox="0 0 16 16"
          className="w-4 h-4 md:w-5 md:h-5"
        >
          <polyline
            points="3 9 7 13 13 3"
            fill="none"
            stroke="#00A651"
            strokeWidth="2.5"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  } else if (type === "na") {
    content = <span>N/A</span>;
  } else if (type === "text") {
    content = blok.text || "";
  } else {
    // unknown or empty value
    content = "";
  }

  return (
    <td
      {...storyblokEditable(blok)}
      className="px-6 py-4 align-top text-[16px] font-normal text-gray-900"
    >
      {content}
    </td>
  );
};

export default ChartCell;
